export function capitalizeFirstLetter(s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function getCookie(name: string): string {
  if (!document.cookie) {
    return '';
  }
  const token = document.cookie
    .split(';')
    .map((c) => c.trim())
    .filter((c) => c.startsWith(`${name}=`));

  if (token.length === 0) {
    return '';
  }
  return decodeURIComponent(token[0].split('=')[1]);
}
